module.exports = __webpack_public_path__ + "img/pr-8.57e4ce1a.png";